export const shuffle = (array) => {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}
export const areEqual = (first, second) => {
   if(first.length !== second.length){
      return false;
   };
   for(let i = 0; i < first.length; i++){
      if(!second.includes(first[i])){
         return false;
      };
   };
   return true;
};
export const oxfordComma = (array) => {
  if (array.length === 2) {
    return array.slice(-2).join(' and ');
  }
  return array.slice(0, -2).join(', ') + 
    (array.slice(0, -2).length ? ', ' : '') + 
    array.slice(-2).join(', and ');
}